import _ from 'lodash';

function SidebarPlayerCtrl($rootScope, $location, $scope, $state, $interval, $window, toastr, AppSettings, AuthService, AnalysisService, BioService, PlanService, PlayerService, CommonService) {
  'ngInject';

  // ViewModel
  const vm = this;
  
  $rootScope.$on('base:sidebarEvent', function(event, data){
    vm.sideBarState = data; // off, open, close
  });

  vm.editPlayer =function(player) {
    $state.go('Service.system', {obj:player});
  };

}

export default {
  name: 'SidebarPlayerCtrl',
  fn: SidebarPlayerCtrl
};
